import { useTranslate } from 'app/[locale]/hooks/useTranslate';
import { SectionTitle } from '../SectionTitle';
import Image from 'next/image';
import { useAttentionTracker } from 'app/[locale]/hooks/useAttentionTracker';

export const MultilingualSection = (): JSX.Element => {
  const { t } = useTranslate();
  const { ref } = useAttentionTracker({ sectionName: 'main_multilingual' });

  return (
    <section
      className="md:space-y-20 space-y-10 md:max-w-homepage md:py-[60px] px-4 md:px-10"
      ref={ref}
    >
      <SectionTitle
        title={t.home.MAIN_MULTILINGUAL_TITLE}
        description={t.home.MAIN_MULTILINGUAL_DESC}
      />
      <Image
        className="md:w-[652px] w-[328px] mx-auto"
        src="/callabo/homepage/multilingual.png"
        width={492}
        height={175}
        alt="multilingual_image"
      />
    </section>
  );
};
